import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const RepRoutes = () => {
  const role = useSelector((state) => state.authentication.role);
  const isRoleAdmin = role === "admin";
  const isRep = role === "rep" && !isRoleAdmin;

  return isRep ? <Outlet /> : <Navigate to="/home" />;
};

export default RepRoutes;
